import { Component, Inject, EventEmitter } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';

import { Note } from '../../../models/evaluation/note.model';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { ArraySortPipe } from '../../../pipes/sort.pipe';
import { FormsModule } from '@angular/forms';


interface DialogData {
  noteText?: string;
  notes: Note[];
  currentPhase?: string;
  noteReadOnly?: boolean;
}

@Component({
  selector: 'app-quick-note-dialog',
  templateUrl: './quick-note-dialog.component.html',
  styleUrls: ['./quick-note-dialog.component.css'],
  imports: [
    FormsModule,
    CommonModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    ArraySortPipe
  ]
})
export class QuickNoteDialogComponent {
  addNote = new EventEmitter();
  hasReturn: boolean;
  isO3: boolean;
  isNoteReadOnly: boolean;

  constructor(
    public dialogRef: MatDialogRef<QuickNoteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {
    this.isO3 = data.currentPhase == "O3";
    this.hasReturn = data.hasOwnProperty('noteText');
    this.isNoteReadOnly = data.noteReadOnly;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  submit() {
    this.addNote.emit(this.data.noteText);
    this.data.noteText = '';
  }

}
